import React, { useState } from 'react';
import './EmpresaN.css';
import { setMenu } from '../actions/index';
import { useDispatch } from 'react-redux';
import { insertCompany } from './general/api'; // Importar la función desde api.js

const EmpresaN = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name_emp: '',
    nit_emp: '',
    address_emp: '',
    phone_emp: '',
    email_emp: '',
    website_emp: '',
    expire_date_emp: '',
    picture_emp: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, picture_emp: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await insertCompany(formData); // Usar la función de la API
      console.log(response); // Verificar la respuesta
      alert('Empresa insertada con éxito');
      dispatch(setMenu('empresaAct')); // Navegar al menú de empresas
    } catch (error) {
      console.error(error);
      alert('Ocurrió un error al insertar la empresa');
    }
  };

  return (
    <div className='empresaN'>
      <h2>Insertar Nueva Empresa</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nombre de la Empresa:
          <input type='text' name='name_emp' value={formData.name_emp} onChange={handleChange} required />
        </label>
        <label>
          NIT:
          <input type='text' name='nit_emp' value={formData.nit_emp} onChange={handleChange} required />
        </label>
        <label>
          Dirección:
          <input type='text' name='address_emp' value={formData.address_emp} onChange={handleChange} required />
        </label>
        <label>
          Teléfono:
          <input type='text' name='phone_emp' value={formData.phone_emp} onChange={handleChange} required />
        </label>
        <label>
          Correo Electrónico:
          <input type='email' name='email_emp' value={formData.email_emp} onChange={handleChange} required />
        </label>
        <label>
          Sitio Web:
          <input type='url' name='website_emp' value={formData.website_emp} onChange={handleChange} />
        </label>
        <label>
          Fecha de Expiración:
          <input type='date' name='expire_date_emp' value={formData.expire_date_emp} onChange={handleChange} required />
        </label>
        <label>
          Logo de la Empresa:
          <input type='file' name='picture_emp' onChange={handleFileChange} required />
        </label>
        <button type='submit'>Insertar Empresa</button>
      </form>
    </div>
  );
};

export default EmpresaN;
